module.exports = __webpack_public_path__ + "img/world.0019ef67.jpg";